const hotels = {
  accommodation: "Akomodasi", // translated 
  hotel: "Hotel", // translated 
  hotels: "Hotel", // translated 
  back: "Kembali", // translated 
  rooms: "Kamar", // translated 
  viewPictures: "Lihat Gambar", // translated 
  showMore: "menampilkan lebih banyak", // translated 
  bookingInformation: "Informasi Pemesanan", // translated 
  cancellationPolicy: "Kebijakan Pembatalan", // translated 
  from: "Dari", // translated 
  to: "Ke", // translated 
  cancellationIs: "pembatalan adalah", // translated 
  free: "bebas", // translated 
  chargeableWithFeeOf: "dikenakan biaya sebesar", // translated 
  prebook: "Pesan terlebih dahulu", // translated 
  guests: "Tamu", // translated 
  payment: "Pembayaran", // translated 
  byClicking: "Dengan mengklik", // translated 
  next: "Berikutnya", // translated 
  youAreAgreeingToOur: "Anda menyetujui kami", // translated 
  termsAndConditions: "syarat dan Ketentuan", // translated 
  previous: "Sebelumnya", // translated 
  cancel: "Membatalkan", // translated 
  mealPlan: "Rencana makan", // translated 
  roomType: "Tipe ruangan", // translated 
  description: "Keterangan", // translated 
  readLess: "Baca Lebih Sedikit", // translated 
  readMore: "Baca selengkapnya", // translated 
  facilities: "Fasilitas", // translated 
  viewLess: "Lihat Lebih Sedikit", // translated 
  viewMore: "Lihat Lebih Banyak", // translated 
  less: "lebih sedikit", // translated 
  more: "lagi", // translated 
  notAvailable_short: "T/A", // translated 
  backToHotelList: "Kembali ke daftar hotel", // translated 
  viewOnMap: "Lihat di peta", // translated 
  sleeps: "Tidur", // translated 
  adults: "Dewasa", // translated 
  yearsOld: "tahun", // translated 
  type: "Jenis", // translated 
  bedding: "Seperai", // translated 
  selectRoom: "Pilih Kamar", // translated 
  selectRooms: "Pilih Kamar", // translated 
  city: "Kota", // translated 
  checkIn: "Mendaftar", // translated 
  checkOut: "Periksa", // translated 
  date: "Tanggal", // translated 
  dates: "tanggal", // translated 
  persons: "orang", // translated 
  stillOnTrialQuestionToUpgrade:
    "Ups! Sepertinya Anda masih dalam keanggotaan uji coba. Anda harus menjadi anggota terkonfirmasi untuk melakukan pemesanan. Apakah Anda ingin meningkatkan versi sekarang?", // translated 
  stillOnTrialQuestionToUpgradeNonElligib:
    "Ups! Sepertinya Anda belum berlangganan. Anda harus menjadi anggota terkonfirmasi untuk melakukan pemesanan. Apakah Anda ingin meningkatkan versi sekarang?", // translated 
  completeProfile: "Silakan lengkapi profil pengguna Anda terlebih dahulu", // translated 
  upgrade: "Meningkatkan", // translated 
  close: "Menutup", // translated 
  viewDetails: "Melihat rincian", // translated 
  name: "Nama", // translated 
  rating: "Peringkat", // translated 
  budget: "Anggaran", // translated 
  orderBy: "Dipesan oleh", // translated 
  priceLowestFirst: "Harga (terendah dulu)", // translated 
  priceHighestFirst: "Harga (yang tertinggi terlebih dahulu)", // translated 
  ratingLowestFirst: "Peringkat (terendah dulu)", // translated 
  ratingHighestFirst: "Peringkat (tertinggi terlebih dahulu)", // translated 
  starRatingAndPrice: "Peringkat Bintang dan Harga", // translated 
  biggestSavingsFirst: "Penghematan Terbesar Terlebih Dahulu", // translated 
  select: "Pilih", // translated 
  reset: "Mengatur ulang", // translated 
  apply: "Menerapkan", // translated 
  filterBy: "Saring berdasarkan", // translated 
  myProfile: "Profil saya", // translated 
  login: "Gabung", // translated 
  roomOnly: "Kamar Saja", // translated 
  bedAndBreakfast: "Tempat Tidur & Sarapan", // translated 
  halfBoard: "Setengah papan", // translated 
  fullBoard: "Lengkap", // translated 
  allInclusive: "Semua Termasuk", // translated 
  filter: "Saring", // translated 
  mapView: "Tampilan peta", // translated 
  results: "hasil", // translated 
  listView: "Tampilan Daftar", // translated 
  newSearch: "Pencarian baru", // translated 
  editSearch: "Sunting Pencarian", // translated 
  all: "Semua", // translated 
  multiple: "Banyak", // translated 
  editProfile: "Sunting profil", // translated 
  backToHotelsList: "Kembali ke Daftar Hotel", // translated 
  roomName: "Nama ruangan", // translated 
  mealType: "Jenis Makanan", // translated 
  freeCancellation: "Pembatalan GRATIS", // translated 
  yes: "Ya", // translated 
  no: "TIDAK", // translated 
  filters: "Filter", // translated 
  cancellationNonRefundable: "Pembatalan tidak dapat dikembalikan", // translated 
  hotelRating: "Peringkat Hotel", // translated 
  any: "Setiap", // translated 
  off: "Mati", // translated 
  performNewSearch: "Lakukan pencarian baru", // translated 
};



export default hotels;
